import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import isValidI18nKey from 'I18n/utils/isValidI18nKey';
import styled from 'styled-components';
import { getMessage } from './MESSAGE';
import { KOALA } from 'HubStyleTokens/colors';
import { devices } from 'signup-constants/styles/viewports.styles';
import { useCurrentStep } from '../hooks/useCurrentStep';
import { getStepConfig } from '../views/getStepConfig';
import { useSelector } from 'react-redux';
import { getPostAccountCreationSteps } from '../store/flow/selectors';
import { useIsFramedCentredModalStep } from '../hooks/useIsFramedCerntredModalStep';
import { H4 } from 'UIComponents/elements/headings';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledBaseMessageCaption = styled.div.withConfig({
  displayName: "BaseMessageCaption__StyledBaseMessageCaption",
  componentId: "y4ajis-0"
})(["", ""], props => props.$isPostAccountCreationStep ? `border-top: 3px solid ${KOALA};
     padding-top: 1.875rem;
     display: flex;
     align-items: center;
     justify-content: center;
     flex-direction: column;

    @media ${devices.tablet} {
      border: none;
      padding-top: 0;
    }` : `
    text-align: center;
    `);
const Caption = styled.div.withConfig({
  displayName: "BaseMessageCaption__Caption",
  componentId: "y4ajis-1"
})(["text-align:center;margin-bottom:3rem;max-width:90%;line-height:30px;span:not(.checked-list-icon){font-size:23px;font-weight:500;}@media ", "{order:2;margin-top:2rem;margin-bottom:0;}"], devices.tablet);
const StyledChildContainer = styled.div.withConfig({
  displayName: "BaseMessageCaption__StyledChildContainer",
  componentId: "y4ajis-2"
})(["", " ", " ", ""], props => !props.isPostAccountCreationStep && `@media ${devices.desktop} {
      height: 140px;
      top ${props.topMargin}px;
      position: relative;
    }`, props => props.hasMessagingAboveContentInLayoutTemplate && `@media ${devices.tablet} {
      height: 140px;
      top ${props.topMargin}px;
      position: relative;
    }`, props => props.isFramedCentredModalStep && `@media ${devices.desktop} {
        left: 75px;
        width: 300px;
    }`);
export const BaseMessageCaption = ({
  children,
  messageKey
}) => {
  const {
    captionImage,
    captionImageHeight,
    topMargin
  } = getMessage(messageKey);
  const hasTitle = isValidI18nKey(`message.${messageKey}.title`);
  const hasSubtitle = isValidI18nKey(`message.${messageKey}.subtitle`);
  const {
    currentStep
  } = useCurrentStep();
  const stepConfig = getStepConfig(currentStep);
  const postAccountCreation = useSelector(getPostAccountCreationSteps);
  const isPostAccountCreationStep = postAccountCreation.includes(currentStep);
  const showMessagingAboveContent = stepConfig ? stepConfig.showMessagingAboveContent : false;
  const {
    isFramedCentredModalStep
  } = useIsFramedCentredModalStep();
  return /*#__PURE__*/_jsxs(StyledBaseMessageCaption, {
    $isPostAccountCreationStep: isPostAccountCreationStep,
    children: [(hasTitle || hasSubtitle) && /*#__PURE__*/_jsxs(Caption, {
      className: messageKey,
      children: [hasTitle && /*#__PURE__*/_jsx(H4, {
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          message: `message.${messageKey}.title`
        })
      }), hasSubtitle && /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: `message.${messageKey}.subtitle`,
        options: {
          captionImage,
          captionImageHeight
        }
      })]
    }), /*#__PURE__*/_jsx(StyledChildContainer, {
      hasMessagingAboveContentInLayoutTemplate: showMessagingAboveContent,
      isFramedCentredModalStep: isFramedCentredModalStep,
      isPostAccountCreationStep: isPostAccountCreationStep,
      topMargin: topMargin,
      children: children
    })]
  });
};